<template>
  <v-app class="pldc" style="height: 100%; max-width: 450px;"
   :class="{on_desktop: $vuetify.breakpoint.smAndUp}"
  >
    <v-system-bar absolute app window color="#004056" style="max-width: 450px" class="d-flex justify-center">
      <img src="@/assets/logo_white_transparent_background.png" height="25px">
    </v-system-bar>
    <v-main style="height: calc(100% - 32px);">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NoNavLayout',
  
  data: () => ({
    keepAliveTimer: null,
  }),

  methods: {
    keepAlive() {
      this.$store.dispatch('auth/loadMe')
    }
  },

  computed: {
    ...mapGetters('auth', ['signedIn'])
  },

  watch: {
    signedIn(is_logged_in) {
      if (!is_logged_in) {
        this.$router.push({ name: 'login' })
      }
    }
  },

  created() {
    // check for life every 2 minutes
    this.keepAliveTimer = setInterval(this.keepAlive, 120 * 1000)
  },

  beforeDestroy() {
    clearInterval(this.keepAliveTimer)
  }
};
</script>

<style>
  html, body {
    height: 100%;
  }

  .v-application--wrap {
    min-height: 100vh !important;
    min-height: -webkit-fill-available !important;
  }
</style>